export const validateInvoiceOrders = (orders) => {
    if (!Array.isArray(orders) || orders.length === 0) {
        throw new Error('Seleccione al menos una orden válida y genere el resumen antes de guardar la factura.');
    }
    for (const order of orders) {
        if (!order || typeof order.iddoc !== 'string' || !order.iddoc.trim()) {
            throw new Error('Hay órdenes sin identificador válido. Revise la selección y genere el resumen nuevamente.');
        }
    }
};
